import { useEffect, useRef, useState } from "react";
import { CalendarRange } from "lucide-react";

const PRESETS = [
  ["week", "Denne uge"],
  ["month", "Denne måned"],
  ["lastmonth", "Sidste måned"],
  ["30", "30 dage"],
  ["90", "90 dage"],
  ["365", "365 dage"],
];

export default function StatsPeriod({ preset, from, to, onPreset, onCustom }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(from || "");
  const [t, setT] = useState(to || "");
  const [err, setErr] = useState("");
  const seg = useRef(null);
  useEffect(() => {
    seg.current?.querySelector(".on")?.scrollIntoView({ block: "nearest", inline: "center" });
  }, [preset]);

  const apply = () => {
    if (!f || !t) return setErr("Vælg både start- og slutdato");
    const a = new Date(f), b = new Date(t);
    if (b < a) return setErr("Slutdato skal være efter startdato");
    if ((b - a) / 86400000 > 730) return setErr("Perioden må højst være 2 år");
    setErr("");
    setOpen(false);
    onCustom(f, t);
  };

  return (
    <div className="st-period" data-testid="stats-period">
      <div className="st-seg" role="tablist" aria-label="Vælg periode" ref={seg}>
        {PRESETS.map(([k, l]) => (
          <button key={k} type="button" role="tab" aria-selected={preset === k}
            className={preset === k ? "on" : ""} onClick={() => onPreset(k)} data-testid={`stats-preset-${k}`}>
            {l}
          </button>
        ))}
        <button type="button" role="tab" aria-selected={preset === "custom"} className={preset === "custom" ? "on" : ""}
          onClick={() => { setF(from || ""); setT(to || ""); setOpen((o) => !o); }} data-testid="stats-preset-custom">
          <CalendarRange size={14} aria-hidden="true" /> Vælg periode
        </button>
      </div>
      {open && (
        <div className="st-custom" data-testid="stats-custom-form">
          <label>Fra<input type="date" value={f} onChange={(e) => setF(e.target.value)} data-testid="stats-custom-from" /></label>
          <label>Til<input type="date" value={t} onChange={(e) => setT(e.target.value)} data-testid="stats-custom-to" /></label>
          <button type="button" className="btn small primary" onClick={apply} data-testid="stats-custom-apply">Vis</button>
          <button type="button" className="btn small" onClick={() => setOpen(false)} data-testid="stats-custom-cancel">Annullér</button>
          {err && <p className="st-err" role="alert" data-testid="stats-custom-error">{err}</p>}
        </div>
      )}
    </div>
  );
}
